require("!!/var/www/melochenator_prod/frontend/node_modules/script-loader/addScript.js")(require("!!/var/www/melochenator_prod/frontend/node_modules/raw-loader/index.js!/var/www/melochenator_prod/frontend/node_modules/metismenu/dist/metisMenu.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/metismenu/dist/metisMenu.js
// module id = 909
// module chunks = 12